import { CUSTOMER_TYPE_SLUGS } from '../../../../modules/apis/sanity'
import { useCurrentUser } from '../../../../modules/context/UserContext'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import { isWithIn24HoursUser } from '../../../../modules/utils'
import { CMSDesktopSection, CMSMobileSection } from '../CMSSection'
import PricingAITutorMembership from '../PricingAITutorMembership'
import PricingBannerListSection from '../PricingBannerListSection'
import PricingEventList from '../PricingEventList'
import PricingFaqSection from '../PricingFaqSection'
import PricingHero from '../PricingHero'
import PricingSwitchCurrency from '../PricingSwitchCurrency'
import DurationSelector from './DurationSelector'
import PackageSelector from './PackageSelector'
import { ProductProvider, productTypeEnum, useFetchB2CProducts, useProductContext } from './ProductContext'
import ProductTypeSelector from './ProductTypeSelector'

export const PRODUCT_TYPE = {
  NORMAL: 19,
  TEENS: 20,
  B2B2C: 21,
  MULTICAMPUS: 22,
  CONFERENCE: 23,
  COMBINED: 24,
} as const

const NewPricing = () => {
  return (
    <ProductProvider>
      <IndividualPricing />
    </ProductProvider>
  )
}

export default NewPricing

const IndividualPricing = () => {
  const isMobile = useIsMobile()
  const { currentUser } = useCurrentUser()

  const { scrollToTarget, productsPayload, productType } = useProductContext()
  const { data: products } = useFetchB2CProducts(productsPayload)

  const isFirstPurchaseBenefitUser = !currentUser || (currentUser && isWithIn24HoursUser(currentUser))
  const isAITutorTab = productType.type == productTypeEnum.AI_TUTOR

  return (
    <>
      <button className="w-full" onClick={scrollToTarget}>
        <PricingHero isAITutorTab={isAITutorTab} />
      </button>
      <div className="mx-auto max-w-[1180px] mb-40">
        <PricingBannerListSection />

        <div className="mt-32 sm:mt-40 flex flex-col gap-y-32">
          {isMobile || <div className="h-8 bg-gray-50 border-t border-gray-10" />}
          <ProductTypeSelector />
          <section className="px-16 sm:px-0 pt-32 pb-16 sm:py-0">
            <PricingEventList isFirstPurchaseBenefitUser={isFirstPurchaseBenefitUser} />
          </section>
          {isAITutorTab || (
            <div className="px-16 sm:px-0 flex flex-col gap-y-16">
              <section className="flex flex-col sm:flex-row justify-between gap-y-16">
                <DurationSelector />
                <div className="self-start inline-flex">
                  <PricingSwitchCurrency />
                </div>
              </section>
              <div className="flex sm:flex-col flex-col-reverse	gap-y-16">
                <PackageSelector products={products} />
              </div>
            </div>
          )}
          {isAITutorTab && <PricingAITutorMembership />}
        </div>

        {!isAITutorTab && isMobile ? (
          <CMSMobileSection slug={isAITutorTab ? 'b2c-aiTutor' : 'b2c-combinedWithOneOnOne'} />
        ) : (
          <CMSDesktopSection slug={isAITutorTab ? 'b2c-aiTutor' : 'b2c-combinedWithOneOnOne'} isPricingPage={true} />
        )}
        {isAITutorTab || <PricingFaqSection slug={CUSTOMER_TYPE_SLUGS.B2C_COMBINED_WITH_ONE_ON_ONE} />}
      </div>
    </>
  )
}
